import { ref } from 'vue'
import type { CockpitKpis, TimeRange } from '@/types/cockpit'
import { fetchCockpitKpis } from '@/api/cockpit'

export function useCockpitKpis() {
  const kpis = ref<CockpitKpis | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function fetch(range: TimeRange): Promise<void> {
    loading.value = true
    error.value = null
    try {
      kpis.value = await fetchCockpitKpis(range)
    } catch {
      error.value = 'admin.cockpit.kpis.error'
    } finally {
      loading.value = false
    }
  }

  return { kpis, loading, error, fetch }
}
